module.exports = __webpack_public_path__ + "img/cashIcon.3d57cbd3.svg";